import React from "react";

// Lazy load nationalities ...
export const NationalityInput = React.lazy(() => import("./NationalityInput_"));
